import { Component, OnInit } from '@angular/core';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { MenuService } from '../../_provider/menu.service';
import { NavController, Platform } from '@ionic/angular';
import { AuthService } from '../../_provider/auth.service';
import { GeneralService } from '../../_provider/general.service';
import { QuickSearchService } from 'src/app/_provider/quick-search.service';
import { environment } from 'src/environments/environment';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { NotificationsPage } from 'src/app/_pages/settings/notifications/notifications.page';
import { NewFeaturesPage } from 'src/app/_pages/new-features/new-features.page';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { CriticismPage } from './criticism/criticism.page';
import { HotkeysComponent } from './hotkeys/hotkeys.component';
import { ClosedNavigationItem } from './navigation.types';
import { DesktopNotificationsService } from 'src/app/_provider/notifications/desktop-notifications.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/_provider/http.service';
import { HttpFunctionResult } from '../HttpFunctionResult';
import { PaymentService } from 'src/app/_provider/payment/payment.service';
import { StripeStatusResponse } from 'src/app/_provider/payment/payment.types';
import { ImpactStyle } from '@capacitor/haptics';


@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})

export class NavigationComponent implements OnInit {

  public isDarkmode: boolean = false;
  public menuOpen: boolean
  public isLogin: boolean = false

  public activatedPage: string = "tabs/home"

  public version: string = ""

  public subscriptionStatus: StripeStatusResponse | undefined = undefined

  public clodesdMenuItems: ClosedNavigationItem[] = [
    {
      type: "button",
      icon: "fa-bars",
      label: "Menu öffnen",
      action: () => this.menu.openMenu()
    },
    {
      type: "button",
      icon: "fa-search",
      label: "Suchen...",
      action: () => this.quickSearch.openQuicksearch()
    },
    {
      type: "seperator"
    },
    {
      type: "button",
      icon: "fa-ticket",
      label: "Tickets",
      activeRoutes: ["tabs/home"],
      action: () => this.navigate('tabs/home')
    },
    {
      type: "button",
      icon: "fa-business-time",
      label: "Ticketzeiten",
      activeRoutes: ["tabs/worktime-timeline"],
      action: () => this.navigate('tabs/worktime-timeline')
    },
    {
      type: "button",
      icon: "fa-table",
      label: "Boards",
      activeRoutes: ["tabs/boards"],
      action: () => this.navigate('tabs/boards')
    },
    {
      type: "button",
      icon: "fa-comment",
      badge: {value: () =>  this.desktopNotificationsSrv.unseenNotifications.length},
      label: "Benachrichtigungen",
      action: () => this.desktopNotificationsSrv.openNotifications()
    },
    {
      type: "seperator"
    },
    {
      type: "button",
      icon: "fa-user-group",
      label: "CRM",
      activeRoutes: ["/tabs/crm"],
      action: () => this.navigate('/tabs/crm')
    },
    {
      type: "seperator"
    },
    {
      type: "button",
      icon: "fa-graph-bar",
      label: "Dashboard",
      activeRoutes: ["/tabs/dashboard"],
      action: () => this.navigate('/tabs/dashboard')
    },
    {
      type: "seperator"
    },
    {
      type: "button",
      icon: "fa-calendar",
      label: "Kalender",
      activeRoutes: ["/tabs/calendar", "/tabs/calendar-mobile"], 
      action: () => this.navigateCalendar()
    },
    {
      type: "seperator"
    },
    {
      type: "button",
      icon: "fa-gear",
      label: "Einstellungen",
      activeRoutes: ["/tabs/settings/new-settings"],
      action: () => this.navigate('/tabs/settings/new-settings')
    },
    {
      type: "button",
      icon: "fa-sign-out",
      label: "Abmelden",
      action: () => this.logout()
    },
  ]


  constructor(
    public darkmode: DarkmodeService, 
    private navCtrl: NavController,
    public auth: AuthService,
    public resizeManager: ResizeManagerService,
    public generalSrv: GeneralService,
    public quickSearch: QuickSearchService,
    public platform: Platform,
    private feedback: FeedbackService,
    private paymentSrv: PaymentService,
    private http: HttpService,
    public desktopNotificationsSrv: DesktopNotificationsService,
    private breadcrumbSrv: BreadcumbService,
    public menu: MenuService) { 
    this.darkmode.isDarkMode.subscribe(result=>{
      this.isDarkmode = result;
    })
    this.darkmode.setStartupMode()

    this.menu.isMenuOpen.subscribe(result=>{
      this.menuOpen = result;
    })
    // this.menu.openMenu()
    this.version = environment.version
  }
  
  async ngOnInit() {
    await this.checkSubscriptionStatus()
  }

  private async checkSubscriptionStatus(){
    const readySub: Subscription = this.http.requestReady.subscribe(async (ready: boolean) => {
      if(!ready) return 
      if(!this.generalSrv.webConfig?.isStandalone || !this.http.token) return

      const result: HttpFunctionResult<StripeStatusResponse> = await this.paymentSrv.getSubscriptionStatus()
      if(readySub) readySub.unsubscribe()

      if(!result.success) return
      this.subscriptionStatus = result.data
      

      if(this.subscriptionStatus.status == "trialing"){
        const labelHTML: string = `
          <b>Testzeitraum</b><br>
          <span style="opacity: 0.5"> Noch ${this.subscriptionStatus.daysToExpire} Tage kostenloser Zugriff</span>
        `

        this.clodesdMenuItems.unshift({
          type: "warning",
          icon: "fa-exclamation-mark",
          background: this.subscriptionStatus.daysToExpire <= 7 ? "rgba(var(--redRGB), 0.15)" : "rgba(var(--yellowRGB), 0.15)",
          label: labelHTML,
          action: () => {
            if(this.auth.includesRole("access_settings")) this.navigate("/tabs/settings/new-settings?setting=subscription")
          }, 
        })
      }
    })
  }
  

  setDarkmode(){
    if (this.isDarkmode){
      this.darkmode.setDarkmode("light")
    }else{
      this.darkmode.setDarkmode("dark") 
    }
  }

  public async navigate(route:string, param?:string){
    if(!param){
      this.activatedPage = route
      if(route == "") this.activatedPage = "tabs/home"
      await this.navCtrl.navigateRoot(`${route}`)
    }else{
      this.activatedPage = `${route}/${param}`
      await this.navCtrl.navigateRoot(`${route}/${param}`)
    }
    this.breadcrumbSrv.routeChanged(route)
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
  }

  public async navigateCalendar(){
    if(window.matchMedia("(max-width: 1050px)").matches || this.platform.is("capacitor")) 
      await this.navigate("/tabs/calendar-mobile")
    else await this.navigate("/tabs/calendar")
  }

  async logout(){
    if(!(await this.feedback.confirm("Möchten Sie sich wirklich abmelden?", "Abmelden", "Abbrechen"))) return
    this.auth.logout()
  }

  public async openNotifications(){
    await this.feedback.openModal(NotificationsPage, {isModal: true})
  }

  public async deleteSettings(){
    await this.generalSrv.deleteSettings()
  }

  public async setBiometric(){
    this.feedback.vibrate(ImpactStyle.Medium)
    if(this.auth.isDemoMode) return 
    await this.auth.toggleActiveBiometric()
    if(this.auth.isBiometricAuth == true){
      const result: boolean = await this.auth.checkBiometricAuth()
      if(!result){
        await this.auth.toggleActiveBiometric()
      }
    } 
  }

  public openQuickSearch(){
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
    this.quickSearch.openQuicksearch()
  }

  public async openCreticism(){
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
    await this.feedback.openModal(CriticismPage)
  }

  public async openNewFeatures(){
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
    await this.feedback.openModal(NewFeaturesPage)
  }

  public async openHotkeys(){
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
    await this.feedback.openModal(HotkeysComponent)
  }

  public openDesktopNotifications(){
    this.desktopNotificationsSrv.openNotifications()
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
  }

  public outsideClicked(){
    if(this.menu.isOpenAfterAnimation) this.menu.closeMenu()
  }
}